import React from 'react';

import { Badge } from '@material-ui/core';
import EditIcon from '@material-ui/icons/Edit';
import { RouteComponentProps } from '@reach/router';

import logo from '../../../../assets/images/club-logo.svg';

import { useBoolean } from '../../../common/Hooks/useBoolean.hook';
import ChangeImageModal from './ChangeImageModal';

interface IProps extends RouteComponentProps {
  clubId?: number;
  editImageEnabled?: boolean;
  profileImage?: string | null | undefined;
  title?: string;
}

const Subheader = (props: IProps) => {
  const [modalIsOpen, , modalToggle] = useBoolean(false);

  const { clubId, title, editImageEnabled, profileImage } = props;

  return (
    <div className="subheader">
      <div className="title-wrapper">
        <>
          <div className="events-image rounded">
            {editImageEnabled ? (
              <>
                <Badge
                  badgeContent={<EditIcon />}
                  onClick={modalToggle}
                  color="primary"
                  className="avatar-badge"
                >
                  <img src={profileImage ? profileImage : logo} className="logo" alt="logo" />
                </Badge>
                {clubId && (
                  <ChangeImageModal
                    clubId={clubId}
                    modalIsOpen={modalIsOpen}
                    modalToggle={modalToggle}
                  />
                )}
              </>
            ) : (
              <img src={profileImage ? profileImage : logo} className="logo" alt="logo" />
            )}
          </div>
        </>

        {title && <h3 className="title">{title.toUpperCase()}</h3>}
      </div>
    </div>
  );
};

export { Subheader };
